import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { ResposeGeneric } from './core/shared/respose-generic';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private uriUserSession = environment.urlServices + 'user-sessions';

  constructor(private httpClient: HttpClient) { }

  getUserData (): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.uriUserSession);
  }
}
